import { createPortal } from "react-dom";
import { Sparkles } from "lucide-react";

// Floating "Rich is speaking" chip shown while any narration plays.
export const SpeakingAvatar = ({ speakerLabel, speakerAvatar }) => createPortal(
  <div
    data-testid="speaking-avatar"
    className="fixed bottom-6 left-6 z-[70] flex items-center gap-4 bg-black/90 backdrop-blur-xl border border-[#F59E0B]/40 rounded-full pl-2 pr-6 py-2 shadow-2xl"
  >
    <span className="relative block w-14 h-14 shrink-0">
      <span className="absolute inset-0 rounded-full border border-[#F59E0B]/60 animate-ping" />
      {speakerAvatar ? (
        <img src={speakerAvatar} alt={speakerLabel} className="relative w-14 h-14 rounded-full object-cover border-2 border-[#F59E0B]" />
      ) : (
        <span className="relative w-14 h-14 rounded-full border-2 border-[#F59E0B] bg-[#FFFFFF] flex items-center justify-center text-[#B45309]"><Sparkles size={22} /></span>
      )}
    </span>
    <span className="flex flex-col">
      <span className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#B45309]">{speakerLabel}</span>
      <span className="flex items-end gap-[3px] h-4 mt-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <span key={i} className="w-[3px] bg-[#F59E0B] rounded-full tacc-eq-bar" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </span>
    </span>
  </div>,
  document.body
);
